import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ProductsService } from '../services/products.service';
import { ProjectManagerService } from '../services/project-manager.service';
import { ObjectAddService } from '../Component(2D and 3D)/3D/ObjectAdd/object-add.service';
import { Select3dService } from '../services/select-3d.service';
import { StageService } from '../services/stage.service';
import { EventLogService, Actions } from '../services/eventLog';
import { environment } from '../../environments/environment';

const gates1 = {
  'id': '64D89642be2T9c7f6f52de6d',
  'application': 'Home',
  'description': 'Gate',
  'height': 1.27,
  'length': 203.2,
  'maxSpacing': {},
  'modelMtl': 'gate3.mtl',
  'modelObj': 'gate3.obj',
  'productGroup': 'Generic',
  'productImg': 'GATE3-LM.png',
  'productImg1': 'GATE3-LM.png',
  'productType': 'Accessory',
  'textures': ['gate_map3.jpg'],
  'width': 101.6
};

const gates2 = {
  'id': '64D8jZ92be2T9c7f6K1kde6d',
  'application': 'Home',
  'description': 'Gate',
  'height': 1.27,
  'length': 203.2,
  'maxSpacing': {},
  'modelMtl': 'gate4.mtl',
  'modelObj': 'gate4.obj',
  'productGroup': 'Generic',
  'productImg': 'GATE4-LM.png',
  'productImg1': 'GATE4-LM.png',
  'productType': 'Accessory',
  'textures': ['gate_map4.jpg'],
  'width': 101.6
};

const gates3 = {
  'id': '64D89642be2wdf7f6f52de6d',
  'application': 'Home',
  'description': 'Gate',
  'height': 1.27,
  'length': 101.6,
  'maxSpacing': {},
  'modelMtl': 'gate.mtl',
  'modelObj': 'gate.obj',
  'productGroup': 'Generic',
  'productImg': 'GATE-LM.png',
  'productImg1': 'GATE-LM.png',
  'productType': 'Accessory',
  'textures': ['gate_map.jpg'],
  'width': 101.6
};

const gates4 = {
  'id': '64D8j1234e2T9c7f6K1kde6d',
  'application': 'Home',
  'description': 'Gate',
  'height': 1.27,
  'length': 101.6,
  'maxSpacing': {},
  'modelMtl': 'gate2.mtl',
  'modelObj': 'gate2.obj',
  'productGroup': 'Generic',
  'productImg': 'GATE2-LM.png',
  'productImg1': 'GATE2-LM.png',
  'productType': 'Accessory',
  'textures': ['gate_map2.jpg'],

  'width': 101.6
};

@Component({
  selector: 'app-add-gates',
  templateUrl: './add-gates.component.html',
  styleUrls: ['./add-gates.component.scss']
})
export class AddGatesComponent implements OnInit {

  @Output() step2Editer = new EventEmitter();

  apiUrl: string = environment.apiUrl;

  public gates: Array<any> = [];

  constructor(
    private productsService: ProductsService,
    private objectAddService: ObjectAddService,
    private select3dService: Select3dService,
    private stageSrvc: StageService,
    private eventLog: EventLogService,
    private projectManagerService: ProjectManagerService
  ) {
  }

  goBack(value) {
    this.step2Editer.emit({ name: value });
  }


  itemClick(gate: any): void {
    this.objectAddService.setEntity(gate);
  }

  remove() {
    const gates = this.select3dService.getSelectedAccessories();
    gates.forEach(gate => this.eventLog.dispatch(new Actions.ObjectDeleteAction(gate)));
  }

  ngOnInit() {
    this.productsService.getAccessories().then(access => {
      if (access && access.length) {
        if (access.filter(acc => acc.description.includes('Gate')).length) {
          this.gates = [...access.filter(acc => acc.description.includes('Gate'))];
          // console.log('this.gates', this.gates);
        } else {
          // this.gates = [gates3, gates4, gates1, gates2];
        }

        // console.log('this.gates', this.gates);
      }
    });
    // this.projectManagerService.saveProduct(gates1);
    // this.projectManagerService.saveProduct(gates2);
  }

}



// WEBPACK FOOTER //
// ./src/app/add-gates/add-gates.component.ts